<template>
  <div class="login-form">
    <h2>Acceso colegiados</h2>
    <hr/>
    <form @submit.prevent="submit()">
      <div class="form-item">
        <label>Usuario</label>
        <input type="text" v-model="credentials.username">
      </div>
      <div class="form-item">
        <label>Contraseña</label>
        <input :type="showPassword ? 'text' : 'password'" v-model="credentials.password">
        <div class="icon_eye pointer" @click="showPassword = !showPassword">
          <img v-if="showPassword" src="@/assets/img/eye.svg" alt="eye">
          <img v-if="!showPassword" src="@/assets/img/eye-slash.svg" alt="eye">
        </div>
      </div>
      <button type="submit">Entrar</button>
    </form>
  </div>
</template>

<script>
import Api from '@/Api';

// Plugins
import notification from '@/utils/plugins/NotificationService';

export default {
  name: 'login-sidebar',
  data() {
    return {
      credentials: {
        username: '',
        password: ''
      },
      showPassword: false,
      submitted: false
    }
  },
  props: {
    credentialsModal: {}
  },
  methods: {
   submit() {
      const params = { 
        username: this.credentials.username,
        password: this.credentials.password
      }
      return Api().post('api/login', params).then((res) => {
        // https://icasalweb.undanet.com/#
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('user', JSON.stringify(res.data.user));
        window.open('http://localhost:8080/#/login?token=' + res.data.token + '&user=' + this.credentials.username + '&pass=' + this.credentials.password, '_self');
      }).catch((res) => {
        if (res.response && res.response.data && res.response.data.Forbidden === 'Access denied') {
          notification.addNotification('El usuario ha sido bloqueado por meter la contraseña de forma errónea 3 veces, contacta con Soporte Técnico', 'error', 10000);
        } else {
          notification.addNotification('Los datos de acceso introducidos son erroneos, por favor inténtalo de nuevo o contacta con Soporte Técnico', 'error', 10000);
        }
      });
    }
  },
  components: {
  }
}

</script>